import React from 'react';
import { IMedicationSetting } from 'types/medicationSetting';
import { getMedicationSetting } from 'api/common';

const useMedicationSetting = (): [IMedicationSetting, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<IMedicationSetting>({});

    const fetchData = async () => {
        if (loading) return;
        try {
            setLoading(true);
            const result = await getMedicationSetting();
            if (!result.error) {
                setData(result.data.data || {});
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    return [data, loading, fetchData];
};

export default useMedicationSetting;
